import gameIds from '../hub/data/GameIds';
import { saveGameState } from '../actions/persistStateActions';

// Every questWorkflowReducer field tracking a bucket of retryable API failures.
// To track a new kind of failure in the same API_FAILURES bucket:
// add the field name here, then wire it into questState.js / the reducer / serverResponseHandler.js
const API_FAILURE_FIELDS = ['observationApiFailures', 'writeResultFailures'];

// saveGameState has no internal ordering guarantee and POSTs a full snapshot with no server-side merge,
// so two overlapping saves here could land out of order and let a stale snapshot silently overwrite a fresher one.
// This queue forces them to run in the order they were requested.
let saveQueue = Promise.resolve();

/**
 * Writes the full API_FAILURES gamestate bucket from the current questWorkflowReducer state.
 */
export const saveApiFailures = () => (dispatch, getState) => {
  const previousSave = saveQueue;
  const currentSave = (async () => {
    try {
      await previousSave;
    } catch {
      // Already logged by the failed call itself; this just lets the queue keep moving.
    }
    const { questWorkflowReducer } = getState();
    const gameDetails = Object.fromEntries(
      API_FAILURE_FIELDS.map(field => [field, questWorkflowReducer[field]]),
    );
    return dispatch(saveGameState(gameIds.API_FAILURES, { gameDetails }));
  })();

  saveQueue = currentSave.catch(() => {}); // the queue itself must never sit rejected and unhandled
  return currentSave;
};

export default {};
